import React, { FC } from "react";
import { Chip as MaterialChip, PaletteChip, ThemeProvider, createTheme } from '@mui/material';
import createPalette, { Palette } from "@mui/material/styles/createPalette";
import { vars } from "../Variables";

const { secondaryFont, textColor, secondaryTextColor } = vars;

interface IChips {
  label: React.ReactNode;
  color?: "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning";
  variant?: "filled" | "outlined";
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  onDelete?: ((event: any) => void);
  deleteIcon?: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  icon?: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  avatar?: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  size?: "small" | "medium";
  sx?: object;
}

declare module '@mui/material/styles' {
  interface Theme { }
  // allow configuration using `createTheme`
  interface ThemeOptions { }
}

const customPalette: any = createPalette({
  primary: {
    main: '#1D183E',
    "100": '#ECF0FC',
  },
  warning: {
    main: '#EAA800',
    "100": '#FBF1D6',
  },
  success: {
    main: '#00A689',
    "100": '#E4F7F3',
  },
})

const theme = createTheme({
  components: {
    MuiChip: {
      styleOverrides: {
        root: {
          fontFamily: secondaryFont,
          borderRadius: '4px',
          height: '38px',
          backgroundColor: customPalette?.primary[100],
          color: customPalette.primary.main,
        },
        label: {
          fontStyle: 'normal',
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: 'normal',
        },

        colorWarning: {
          backgroundColor: customPalette?.warning[100],
          color: customPalette.warning.main,
        },

        colorSuccess: {
          backgroundColor: customPalette?.success[100],
          color: customPalette.success.main,
        },
      }
    }
  }
})

export const Chips: FC<IChips> = ({
  color,
  label,
  variant,
  onDelete,
  onClick,
  deleteIcon,
  icon,
  avatar,
  size,
  sx
}) => {
  return (
    <ThemeProvider theme={theme}>
      <MaterialChip
        avatar={avatar}
        icon={icon}
        deleteIcon={deleteIcon}
        onDelete={onDelete}
        onClick={onClick}
        label={label}
        color={color}
        variant={variant}
        size={size}
        sx={sx}
      />
    </ThemeProvider>
  )
}